
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import Swiper from '@util/swiper.jquery.min.js'
import { $util } from "@util/util.js";
import API from "@api/index.js";
export default class PersonalGoodsWapView extends BaseView {
  constructor(model) {
    super(model);
    this._model._view = this;
    // console.log('私人订制页面',this._model);
    this._parentEl = this._model._parent._view._similarityBoxEl;
    this._el = null;
    this.materialCode = '';
    // 手机刻字的官方签名 3 手机刻字的自定义刻字 2 这里从列表传过来的为默认选中的
    this.ptMode = this._model._parent._data.personalizations[0]?.ptmode || '';
    this.inputWordsLimit = 15;
    // 刻字的表情占位长度常规为1.5 手机为1
    this.emojiLength = 1.5;
    this.ptUrl = '';
    this.submitInfo = null;
    this.selectedFontId = null; 
    this.ttfUrl = null;
    this.fontName = null;
    this.selectedFontFamily = null;
  }
  setSubmitInfo(v){
    this.submitInfo = v;
  }
  setPtUrl(v){
    this.ptUrl = v;
  }
  setPtMode(v){
    this.ptMode = v;
  }
  getGoods(ptside) {
    let data = this._model._cSideData[0];
    let html = '';
    let datas = '';
    let deviceType = null;
    // 根据产品类型设置设备类型
    const deviceTypeMap = {
      'T': 'tablet',
      'C': 'noteBook',
      'Z': 'mobilePhone'
    };
    deviceType = deviceTypeMap[this._model.machineInfo?.machineProductType] || 'noteBook';
    this._model._parent._data.personalizations.map((item, index) => {
      if (item.ptside == 'C' || item.ptside == 'Z') {
        datas = item
      }
    })
    let { machineInfo } = this._model;
    const { mobileList = [] } =  machineInfo;
    // 仅保留 tabTitle 非空的 tab 参与展示与激活（tabTitle 为空表示后端隐藏该 tab）
    const validMobileList = (mobileList || []).filter(item => item?.tabTitle);
    this.setPtMode(datas?.ptmode);
    let signatureInfo = {};
    let letteringInfo = {};
    signatureInfo = mobileList?.find(item => item?.ptMode === '3') || {};
    letteringInfo = mobileList?.find(item => item?.ptMode === '2') || {};
    // 当前 ptMode 只在“有效 tab”里查找；若不在，强制重置为第一个有效 tab
    const findIndex = validMobileList.findIndex(item => item?.ptMode === this.ptMode);
    if(findIndex == -1){
      const fallbackTab = validMobileList?.[0] || mobileList?.[0];
      this.setPtMode(fallbackTab?.ptMode || '2');
      if(this.ptMode === '3'){
        // 被强制切到明星签名：不做默认选中，等用户主动勾选；预览显示干净机器图
        this.setSubmitInfo(null);
        this.setPtUrl(machineInfo?.url);
      }else{
        this.setPtUrl(fallbackTab?.ptUrl || machineInfo?.url);
      }
    }else{
      if(this.ptMode == '3'){
        const activeObj = signatureInfo.subList?.find(item => item.ptPicCode == datas.ptpicCode);
        if(activeObj){
          this.setSubmitInfo(activeObj);
          this.setPtUrl(activeObj.ptUrl);
        }else{
          // 原签名已下架 / ptpicCode 匹配不到：视为未选中，等用户主动勾选
          this.setSubmitInfo(null);
          this.setPtUrl(machineInfo?.url);
        }
      }else{
        this.setPtUrl(machineInfo?.url);
      }
    }
      
    if(deviceType == 'mobilePhone'){
      this.inputWordsLimit = 6;
      this.emojiLength = 1;
    }else{
      this.inputWordsLimit = 15;
    }
    
    html += `
    <div class="pop_right_main">
        <div class="pop_right_head">
          <img class="pop_right_return" latag='${this.getPrintInfo(ptside, machineInfo).latagWord_Back}' src="//p4.lefile.cn/fes/cms/2021/07/08/zti3stcolzookvtuq2p5hroo6gcvdi292749.png">
          <h6>${this.getPrintInfo(ptside, machineInfo).title}</h6>
          <span class="AC_face_exp_show" latag='${this.getPrintInfo(ptside, machineInfo).latagWord_Notice}'>${this.getPrintInfo(ptside, machineInfo).questionWord}</span>
        </div>
        <div class="service_list_main" style="display: none;">
          <div class="service_pro">
            <div class="img_box">
              <div class="srdz_img_con">
                <img id="srdz_spimage" src=${this._model._parent._data.imgUrl}></div>
            </div>
            <div class="srdz_price_wrap">
              <div>
                <p class="srdz_pop_mall">
                  <i>¥</i>
                  <span id="srdz_spprice">${this._model._parent._data.price.showAmount}</span>
                </p>
                <p class="srdz_pop_code">商品编号:
                  <span id="srdz_spbh">${this._model._parent._data.id}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="srdz_option_list">
            <div class="pro_customed_scroll_wrap">
              <div class="title">刻字费 ￥${datas?.price}</div>
              <textarea id="onClickInputs" tag="onClickInputs" maxlength="16" placeholder="请输入所刻内容（文字长度不超过15个汉字）">${datas.ptword}</textarea> 
              <img class="person_text" src="//p4.lefile.cn/product/adminweb/2021/03/30/N5ZYhUxs2vq8krj4cJg8SWniP-5113.jpg" />
              <p class="tip">*效果图只做参考，实际效果以刻字实物为准！</p>
            </div>
          </div>
        </div>
      <div class="carve_main">
        <div class="carve_main_preview" style="${deviceType == 'mobilePhone' ? 'height:2rem' : ''}">
        ${this.getImgContent(deviceType,machineInfo,signatureInfo,letteringInfo)}
        </div>
        <h6>深色机型浅色刻字，浅色机型深色刻字</h6>
        <p>*效果图只做参考，实际效果以刻字实物为准</p>
        ${this.getEditContent(deviceType,machineInfo,signatureInfo,letteringInfo,datas)}
      </div>
      <div class="service_choise_btn" tag="presonalOkC"  price="${data?.price}" priceName="${data?.priceName}" code="${data?.code}">
        <input type="button" id="dz_qd" tag="presonalOk" value="确定" style="background: rgb(226, 35, 26);">
      </div>
      <div class="carve_foot">
            <div class="carve_price">
                <span>刻字价：￥</span><b>${data?.activityPrice ?? ''}</b>${(data && data.activityPrice != data.price) ? `<s>￥${data.price}</s>` : ''}
            </div>
            <div price="${data?.price}" priceName="${data?.priceName}" code="${data?.code}" machineProductType="${machineInfo?.machineProductType}" currentPtMode="${this.ptMode}" ptside="${datas?.ptside}" pttype="${datas?.pttype}" class="carve_foot_ensure sideC_submitOk" latag='latag_wap_购物车_私人定制${datas?.ptside}面_0_null_确认刻字'>
                确定刻字
            </div>
      </div>
      <div class="AC_face_exp">
        <div class="AC_face_exp_content">
        ${this.getQuesitonPart(ptside)}
        </div>
        <img class="AC_face_exp_close" src="//p1.lefile.cn/fes/cms/2022/04/22/i7motk5dgil0l8s7120uck0cbdl35y376743.png">
      </div>
      `
    return html;
  }
  // 获取上边显示部分
  getImgContent(deviceType, machineInfo, signatureInfo, letteringInfo) {
    // 设备类型对应的HTML模板
    const templates = {
      tablet: () => {
        const isSignatureMode = this.ptMode === '3';
        const baseHTML = `
          <div class="tablet-box">
            <img class="tablet-C-detail-wap-img" src="${this.ptUrl}">
        `;
        
        return isSignatureMode 
          ? `${baseHTML}</div>`
          : `${baseHTML}<div class="lenovo-emoji carve_main_preview_tablet" style="right:3%; bottom:22.5%"></div></div>`;
      },
  
      mobilePhone: () => {
        const isSignatureMode = this.ptMode === '3';
        const baseHTML = `
          <div class="tablet-box">
            <img class="tablet-C-detail-wap-img" src="${this.ptUrl}">
        `;
        return isSignatureMode 
          ? `${baseHTML}</div>`
          : `${baseHTML}<div class="lenovo-emoji carve_main_preview_mobilePhone"></div></div>`;
      },
      noteBook: () => {
        const isSignatureMode = this.ptMode === '3';
        
        return isSignatureMode
          ? `<div class="carve_main_preview_img"><img class="noteBook_ptUrl" src="${this.ptUrl}"></div>`
          : `
            <div class="carve_main_preview_img">
              <img class="noteBook_ptUrl" src="${this.ptUrl}">
              <div class="lenovo-emoji carve_main_preview_t"></div>
              <div class="lenovo-emoji carve_main_preview_b"></div>
            </div>
          `;
      }
    };
  
    // 返回对应设备类型的HTML，如果没有匹配则返回空字符串
    return templates[deviceType]?.() || '';
  }
  getEditContent(deviceType, machineInfo, signatureInfo, letteringInfo, datas){
    var that = this;
    // 公共的HTML模板
    const getCommonHTML = () => {
      // 只渲染 tabTitle 非空的 tab；tabTitle 为空的 tab 完全不展示
      const validMobileList = (machineInfo?.mobileList || []).filter(item => item?.tabTitle);
      const hasVisibleTabs = validMobileList.length > 0;
      const tabsHtml = validMobileList.map((item) => {
        const target = item.ptMode === '3' ? 'signature' : 'lettering';
        return `<div class="lettering_tabs_item" latag="latag_wap_购物车_${datas?.ptside}面私定弹层_${datas?.ptside}面刻字_切换tab按钮" data-target="${target}" data-ptmode="${item.ptMode}">${item.tabTitle}</div>`;
      }).join('');
      return `
        <div class="carve_main_carving" style="${hasVisibleTabs ? 'padding-top: 0' : ''}">
          ${hasVisibleTabs ? `
            <div class="lettering_tabs">
              ${tabsHtml}
            </div>
          ` : ''}
          
          <div class="lettering_content signature">
            ${signatureInfo?.subList?.map((item, index) => `
              <div class="lettering_content_signature_item">
                <img class="lettering_content_signature_itemImg ${this?.submitInfo?.ptPicCode == item?.ptPicCode ? 'lettering_content_signature_itemImg_active' : 'lettering_content_signature_itemImg_default'}" 
                    src="${item?.ptEffectUrl}" 
                    data-ptpiccode="${item?.ptPicCode}"
                    data-pturl="${item?.ptUrl}" 
                    data-pteffecturl="${item?.ptEffectUrl}" 
                    latag="latag_wap_购物车_${datas?.ptside}面私定弹层_${datas?.ptside}面刻字_选择艺人签名"
                    />
                <div class="lettering_content_signature_itemText">${item?.tabContent}</div>
              </div>
            `).join('')}
          </div>
          
          <div class="lettering_content lettering">
            <div id="carve_input">
              <input id="text-input" placeholder="请输入刻字内容..." maxlength="${['noteBook','tablet'].includes(deviceType) ? '16' : '6'}"/>
              <img class="carve_clear_input" latag="latag_wap_购物车_${datas?.ptside}面私定弹层_0_null_清空刻字输入" src="//p3.lefile.cn/fes/cms/2023/02/28/7f4uwox77b16mmfjiuxyza34cai6an460347.png">
            </div>
            <p class="personal_text_content_r_remind">
              ${['noteBook','tablet'].includes(deviceType) ? '最多可输入15个汉字或字符' : '文字长度不能超过6个汉字'}
            </p>
            ${that.getSwitchTypeface(machineInfo?.mobileList)}
            <div class="carve_emojis_box"></div>
          </div>
        </div>
      `;
    };
    
    // 公共的事件绑定函数
    const bindCommonEvents = () => {
      // 有效 tab（tabTitle 非空）不足 2 个时，调整自定义刻字区域的上间距
      const validMobileListLen = (machineInfo?.mobileList || []).filter(item => item?.tabTitle).length;
      if (validMobileListLen < 2) {
        $('.lettering').css('marginTop', '0.3rem');
      }

      // 初始化显示状态
      $(`.lettering_tabs_item[data-ptmode=${this.ptMode}]`).addClass('lettering_tabs_itemActive');
      if (this.ptMode === '3') {
        $('.lettering').hide();
      } else {
        $('.signature').hide();
      }

      // Tab切换事件
      $('.lettering_tabs_item').off('click').on('click', function() {
        $('.lettering_tabs_item').removeClass('lettering_tabs_itemActive');
        $(this).addClass('lettering_tabs_itemActive');
        
        const target = $(this).data('target');
        const ptMode = $(this).data('ptmode');
        that.setPtMode(ptMode);
        let currentPtUrl = '';
        if (that.ptMode == '3') {
          
          // 之前切换过明星签名
          if(that.submitInfo?.ptPicCode){
            currentPtUrl = that.submitInfo.ptUrl;
            that.setSubmitInfo(that.submitInfo);
            that.setPtUrl(currentPtUrl);
          // 没切换过明星签名  
          }else{
            currentPtUrl = signatureInfo.subList[0].ptUrl;
            that.setSubmitInfo(signatureInfo.subList[0]);
            that.setPtUrl(currentPtUrl);
          }
          //小框加上选中
          $(`.lettering_content_signature_itemImg[data-ptpiccode="${that.submitInfo.ptPicCode}"]`)
          .removeClass('lettering_content_signature_itemImg_default')
          .addClass('lettering_content_signature_itemImg_active');
          
          if(deviceType == 'noteBook'){
            $('.carve_main_preview_img').html(`<img class="noteBook_ptUrl" src="${currentPtUrl}"></img>`);
          }
          if(deviceType == 'mobilePhone'){
            $('.tablet-box').html(`<img class="tablet-C-detail-wap-img" src="${currentPtUrl}">`);
          }
          if(deviceType == 'tablet'){
            $('.tablet-box').html(`<img class="tablet-C-detail-wap-img" src="${currentPtUrl}">`);
          }
        // 点的自定义的tab  
        } else {
          currentPtUrl = machineInfo?.url;
          if(deviceType == 'noteBook'){
            $('.carve_main_preview_img').html(
           `<img class="noteBook_ptUrl" src="${currentPtUrl}">
            <div class="lenovo-emoji carve_main_preview_t"></div>
            <div class="lenovo-emoji carve_main_preview_b"></div>`);
          }
          if(deviceType == 'mobilePhone'){
            $('.tablet-box').html(
           `<img class="tablet-C-detail-wap-img" src="${currentPtUrl}">
            <div class="lenovo-emoji carve_main_preview_mobilePhone"></div>`);
          }
          if(deviceType == 'tablet'){
            $('.tablet-box').html(
           `<img class="tablet-C-detail-wap-img" src="${currentPtUrl}">
            <div class="lenovo-emoji carve_main_preview_tablet" style="right:3%; bottom:22.5%"></div>`);
          }
          that.priewCarveText();
        }
        // 内容先全部隐藏
        $('.lettering_content').hide();
        // 展示明星签名或自定义刻字内容
        $(`.${target}`).show();
      });

      // 签名选项点击事件
      $('.lettering_content_signature_itemImg').off('click').on('click', function() {
        $('.lettering_content_signature_itemImg')
          .removeClass('lettering_content_signature_itemImg_active')
          .addClass('lettering_content_signature_itemImg_default');
        
        $(this)
          .removeClass('lettering_content_signature_itemImg_default')
          .addClass('lettering_content_signature_itemImg_active');
        
        const ptUrl = $(this).data('pturl');
        const ptPicCode = $(this).data('ptpiccode');
        const itemData = signatureInfo.subList.find(item => item.ptPicCode == ptPicCode);
       
        if(deviceType == 'noteBook'){
          $('.carve_main_preview_img').html(`<img class="noteBook_ptUrl" src="${ptUrl}"></img>`);
        }
        if(deviceType == 'mobilePhone'){
          $('.tablet-box').html(`<img class="tablet-C-detail-wap-img" src="${ptUrl}">`);
        }
        if(deviceType == 'tablet'){
          $('.tablet-box').html(`<img class="tablet-C-detail-wap-img" src="${ptUrl}">`);
        }
        that.setSubmitInfo(itemData);
        that.setPtUrl(ptUrl);
        that.setPtMode(itemData.ptMode)
      });
    };
  
    // 根据设备类型返回对应的HTML
    let html;
    if (['mobilePhone', 'tablet', 'noteBook'].includes(deviceType)) {
      html = getCommonHTML();
      
      // 延迟绑定事件
      setTimeout(() => {
        bindCommonEvents();
        that.bindFontSwitchEvent();
      }, 0);
    }
    return html;
  }
  
  getSwitchTypeface(mobileList) {
    let customItem = this._model._parent._personalGoods?._cSideData?.[0] || {};
    let apiFontList = customItem?.fontList || [];
  
    // 如果没有字体列表，返回空字符串（不显示字体选择器）
    if (apiFontList.length === 0) {
      return '';
    }
  
    let fontList = apiFontList.map(item => ({
      fontId: item.fontId,
      fontName: item.fontName,
      ttfUrl: item.ttfUrl,
      fontFamily: item.fontId + '-font'
    }));
  
    // 动态注入字体样式
    let style = document.createElement('style');
    let css = '';
    fontList.forEach(item => {
      if (item.ttfUrl) {
        css += `
          @font-face {
            font-family: '${item.fontFamily}';
            src: url('${item.ttfUrl}') format('truetype');
          }
        `;
      }
    });
    if (css) {
      style.innerHTML = css;
      document.head.appendChild(style);
    }
  
    let html = `<div class="font-selector">
      <p class="font-label">选择字体</p>
      <div class="font-list">`;
  
    fontList.forEach((font, index) => {
      const activeClass = index === 0 ? 'active' : '';
      html += `<div class="font-item ${activeClass}" 
          data-fontid="${font.fontId}" 
          data-fontfamily="${font.fontFamily}"
          data-ttfurl="${font.ttfUrl}">
          <div class="font-preview" style="font-family:${font.fontFamily}">Aa</div>
          <div class="font-name" style="font-family:${font.fontFamily}">${font.fontName}</div>
        </div>`;
    });
  
    html += `</div></div>`;
    return html;
  }
  
  // 预览C面刻字效果
  priewCarveText() {
    var that = this;
    const inputText = $('#text-input').val() || '';
    const isTablet = that._model.machineInfo?.machineProductType === 'T';
    const isMobilePhone = that._model.machineInfo?.machineProductType === 'Z';
  
    // 获取当前选中的字体族（如果没有选择或没有字体列表，使用默认字体栈）
    let currentFontFamily = that.selectedFontFamily;
    if (!currentFontFamily) {
      currentFontFamily = 'Helvetica Neue, Helvetica, Arial, Microsoft Yahei, 微软雅黑, PingFang SC, Heiti, sans-serif, SimSun, serif';
    }
  
    // 确保 emojiMap 存在（在 initCFace 中通过表情加载后挂载到 that.emojiMap）
    const emojiMap = that.emojiMap || new Map();
  
    // 生成带有 span 的 HTML
    let html = '';
    for (let ch of inputText) {
      if (emojiMap.has(ch)) {
        html += `<span class="wap-emoji-font">${ch}</span>`;
      } else {
        html += `<span style="font-family: ${currentFontFamily};">${ch}</span>`;
      }
    }
  
    if (isTablet) {
      $('.carve_main_preview_tablet').html(html);
    } else if (isMobilePhone) {
      $('.carve_main_preview_mobilePhone').html(html);
    } else {
      $('.carve_main_preview_t').html(html);
      $('.carve_main_preview_b').html(html);
    }
  }
  
  // 喷绘的：笔记本、平板、台式机
  getItemA_Or_L(ptside) {
    let { machineInfo } = this._model;
    let datas = this._model._parent._data;
    let personalizations = datas.personalizations;
    let html = '';
    html += `
    <div class="pop_right_main">
        <div class="pop_right_head">
          <img class="pop_right_return" latag='${this.getPrintInfo(ptside, machineInfo).latagWord_Back}' src="//p4.lefile.cn/fes/cms/2021/07/08/zti3stcolzookvtuq2p5hroo6gcvdi292749.png">
          <h6 class="A_">${this.getPrintInfo(ptside, machineInfo).title}</h6>
          <span class="AC_face_exp_show" latag='${this.getPrintInfo(ptside, machineInfo).latagWord_Notice}'>${this.getPrintInfo(ptside, machineInfo).questionWord}</span>
        </div>
        <div class="pop_right_A_main">
          <div class="A_pre_img_box">
            <img class="A_pre_img" src="" thumb_src=''>
          </div>
          <div class="A_price_nav_box">
            <ul class="A_price_nav_ul">

            </ul>
            <div class="A_price_nav_line"></div>
          </div>
          <div class="A_imgs_box">
            <div class="A_imgs_box_l">
              <ul class="A_imgs_box_l_ul">
                <li class="A_img_class_nav_li A_img_class_nav_li_active">自然</li>
                <li class="A_img_class_nav_li">自然</li>
                <li class="A_img_class_nav_li">自然</li>
                <li class="A_img_class_nav_li">自然</li>
              </ul>
            </div>
            <div class="A_imgs_box_r">
              <img src="//p1.lefile.cn/product/btcp/relase/customworkflow/2019/01/04/87C34D1581954B26A7A1215E2C5F8674.jpg">
            </div>
          </div>
        </div>
        <div class="service_list_main" style="display: none;">
          <div class="service_pro">
            <div class="img_box">
              <div class="srdz_img_con">
                <img id="srdz_spimage" src=${datas.imgUrl}>
              </div>
            </div>
            <div class="srdz_price_wrap">
              <div>
                <p class="srdz_pop_mall">
                  <i>¥</i>
                  <span id="srdz_spprice">${datas.price.showAmount}</span>
                </p>
                <p class="srdz_pop_code">商品编号:
                  <span id="srdz_spbh">${datas.id}</span>
                </p>
              </div>
            </div>
            <i class="fr iconfont icon-close srdz_pop_close" tag="onClickNoneC"></i>
          </div>
          <div class="srdz_option_list">
            <div class="pro_customed_pric">
              <div class="pro_customed_pric_container">
                <div class="swiper-container" id="swiper2">
                  <div class="swiper-wrapper">
                    ${this.titleTab()}
                  </div>
                </div>
              </div>
            </div>
            <div class="pro_customed_list_container">
              <div class="pro_customed_pric_list" style="display: block;">
                <div class="pro_customized_nav vertical_nav">
                  <ul class="pro_category_cover">
                    ${this.getLeftNav()}
                  </ul>
                </div>
                <div class="customized_list clearfix">
                ${this.getRightList()}
              
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="carve_foot">
        <div class="carve_price">
            <span>喷绘价：￥</span><b>123</b><s>2</s>
        </div>
        <div class="carve_foot_ensure ${this.getPrintInfo(ptside).submitClass}" latag='latag_wap_购物车_私人定制A面_0_null_确认喷绘'>
            确定喷绘
        </div>
      </div>
    </div>
    <div class="service_choise_btn"  tag="presonalOkA">
      <input type="button" id="dz_qd" value="确定" style="background: rgb(226, 35, 26);">
    </div>
    <div class="${ptside=='L' ? 'L_face_exp' : 'AC_face_exp'}">
        <div class="${ptside=='L' ? 'L_face_exp_content' : 'AC_face_exp_content'}">
        ${this.getQuesitonPart(ptside)}
        </div>
        <img class="AC_face_exp_close" src="//p1.lefile.cn/fes/cms/2022/04/22/i7motk5dgil0l8s7120uck0cbdl35y376743.png">
      </div>
      `
    return html;
  }
  getPrintInfo(ptside, machineInfo = null) {
    let info = {
      title:'',
      questionWord:'',
      latagWord_Back:'',
      latagWord_Notice:'',
      submitClass:''
    }
    if(machineInfo?.machineProductType === 'Z'){
      info = {
        title: machineInfo?.machineTitle,
        questionWord: '哪里为转轴？',
        latagWord_Back:'latag_wap_购物车_私人定制转轴_0_null_返回',
        latagWord_Notice: 'latag_wap_购物车_私人定制转轴_0_null_背面解释文案'
      }
      return info;
    }
    if(machineInfo?.machineProductType === 'T'){
      // 平板 - 喷绘前端写 刻字从后端取
      info = {
        title: ptside === 'A' ? '背面喷绘' : machineInfo?.machineTitle,
        questionWord: '平板背面？',
        latagWord_Back:'latag_wap_购物车_私人定制背面_0_null_返回',
        latagWord_Notice: 'latag_wap_购物车_私人定制背面_0_null_背面解释文案'
      }
      return info;
    }
    if(ptside == 'A'){
      info.title = 'A面喷绘';
      info.questionWord = 'A面/C面？';
      info.latagWord_Back = 'latag_wap_购物车_私人定制A面_0_null_返回';
      info.latagWord_Notice = 'latag_wap_购物车_私人定制A面_0_null_A面/C面解释文案';
      info.submitClass = 'sideA_submitOk';
    }else if(ptside == 'C'){
      info.title = 'C面刻字';
      info.questionWord = 'A面/C面？';
      info.latagWord_Back = 'latag_wap_购物车_私人定制C面_0_null_返回';
      info.latagWord_Notice = 'latag_wap_购物车_私人定制C面_0_null_A面/C面解释文案';
    }else if(ptside == 'L'){
      info.title = '官方图库';
      info.questionWord = '左侧透明机箱？';
      info.latagWord_Back = 'latag_wap_购物车_私人定制L面_0_null_返回';
      info.latagWord_Notice = 'latag_wap_购物车_私人定制L面_0_null_L面解释文案';
      info.submitClass = 'sideL_submitOk';
    }
    return info;
  }
  getLeftNav() {
    let html = "";
    this._model._pictures.forEach((item, index) => {
      html += ` 
              <li class="srdz_category_list" index=${index} code=${item.code}>
                <a class="paintimg_category mutil_line" href="javascript:;">${item.cateName}</a>
              </li>
          `
    })
    return html
  }
  getQuesitonPart(ptside){
    let html = "";
    if(ptside == 'A' || ptside == 'C' || ptside == 'Z'){
      const isTablet = this._model.machineInfo?.machineProductType === 'T' ? true : false;
      const isMobilePhone = this._model.machineInfo?.machineProductType === 'Z' ? true : false;
      if(isTablet){
        html += `
          <h6 style="margin-top:0">平板背面定义</h6>
          <img src="//p1.lefile.cn/fes/cms/2025/07/25/x8t0c3sdqyg5dzg1rl1lheo8m3piaq149805.png">
          <p>平板的背板面（非屏幕面），有logo的一面</p>
        `;
      }else if(isMobilePhone){
        html += `
          <h6 style="margin-top:0">转轴定义</h6>
          <img src="//p1.lefile.cn/fes/cms/2025/09/10/eca9eg2vur3s15u3uqvqruam49xepk777563.png">
          <p>转轴位于手机屏幕中间背部位置</p>
        `;
      }else{
        html += `<h6>A面定义</h6>
          <img src="//p3.lefile.cn/fes/cms/2022/09/15/cto9scncr2q92ohs8p28702ctt1fnh425694.png">
          <p>即顶盖，是指合上屏幕就看到的那一面，也就是笔记本logo所在的那一面</p>
          <h6>C面定义</h6>
          <img src="//p2.lefile.cn/fes/cms/2022/09/15/x0sp88zjr9jvkfro9f5p3wmxyro6pm596997.png">
          <p>即键盘所在面（但不包括键盘）</p>
        `;
      }
    }else if(ptside == 'L'){
      html += `<h6>左侧透明机箱定义</h6>
      <div class="desktop_tips_content">
        <img class="img_desktop_left" src="//p2.lefile.cn/fes/cms/2025/04/25/vhs81y5dv0w3u3s695w9rnn9051ex6842618.png">
      </div>
      <p>是指台式电脑机箱的侧面板采用透明材质设计（通常为钢化玻璃或亚克力），允许用户直接观察机箱内部硬件（如主板、显卡、散热器、RGB灯效等）的一种设计风格。</p>
      `;
    }
    return html;
  }
  titleTab() {
    let html = "";
    // console.log(this._model._aSideData)
    this._model._aSideData.forEach((item, index) => {
      html += `
        <div class="swiper-slide pro_customed_list" tag="onClicknavLi" index="${index}" codeNav="${item.code}" price="${item.price}" priceName="${item.showPrice}">
          <a href="javascript:;">${item.showPrice}</a></div>
        `
    })
    return html
  }
  getRightList() {
    let html = "";

    this._model._pictures.forEach((item, index) => {
      let htmls = ''
      html += ` 
        <ul class="clearfix onClickUl">
            ${item.picArr.map((items, index) => {
        htmls += ` <li tag="onMouseoverTag" name="${items.name}" code="${items.code}" data-large="${items.path}" >
                <div class="customized_info">
                  <a href="javascript:;">
                    <div class="img_box">
                      <img src="${items.path}" alt=""></div>
                    <h6>${items.name}</h6></a>
                </div>
              </li>`
      }),
        htmls
        }       
        </ul>
        `
    })
    return html
  }
  // 字体切换方法
  bindFontSwitchEvent() {
    const that = this;
    $(document).off('click', '.font-item').on('click', '.font-item', function () {
      $('.font-item').removeClass('active');
      $(this).addClass('active');
  
      const fontFamily = $(this).data('fontfamily');
      const fontId = $(this).data('fontid');
      that.selectedFontId = fontId;
      that.fontName = $(this).find('.font-name').text();
      that.ttfUrl = $(this).data('ttfurl');
      that.selectedFontFamily = fontFamily;
  
      // 输入框应用字体组合（用户字体 + emoji fallback）
      const inputFontFamily = `${fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
      $('#text-input').css('font-family', inputFontFamily);
  
      // 刷新预览区（重新生成带 span 的 HTML）
      if (typeof that.priewCarveText === 'function') {
        that.priewCarveText();
      }
    });
  }
  
  render(es, index, sec, materialCode) {
    let html = "";
    // 笔记本A面喷漆 台式机左面喷漆
    if (es == "A" || es == "L") {
      html = `${this.getItemA_Or_L(es)}`;
      $("#customized_pop").html(html);
      this._el = $("#customized_pop");
    // 笔记本C面刻字 平板背面刻字 手机刻字
    } else if(es == "C") {
      html = `${this.getGoods(es)}`;
      $("#customized_pop_c").html(html);
      this._el = $("#customized_pop_c");
    }
    // 每次render都清空选择了几件服务
    this.materialCode = materialCode;
    this.regEvent([index, sec], es);
    var swiper2 = new Swiper('#swiper2', {
      slidesPerView: "auto",
      spaceBetween: 19,
      freeMode: true,
    });
  }
  regEvent(index, es) {
    let that = this;
    const goodsCodes = that._model._parent._data.id
    const imgPriceData = {
      price: '',
      activityPrice: '',
      priceName: '',
      codeNav: ''
    }
    const selectedImgMsg = {
      code: '',
      name: '',
      price: '',
      priceName: '',
      codeNav: ''
    }

    // 获取选中图片的pttype
    function getSelectedImgPttype(data, ptpicCode) {
      for (let item of data) {
        // 找到当前选中的官喷图片对象
        const img = item.picArr.find(imgs => imgs.code === ptpicCode)
        if (img) {
          return img.pttype || 1
        }
      }
      return 1
    }

    commonFun(es)
    switch (es) {
      case "A":
        // 渲染A面
        renderA()
        break;
      case "C":
        // 渲染C面
        initCFace()
        API.getPersonalCarveEmojis().then(res => {
          const data = res.t.res.emojiList
          let emojiList = data.reduce((pre, cur, index) => {
            return pre + `<span class="emoji_item_font emoji lenovo-emoji" emoji="${cur.code.replace('&#', '_emoji_')}">${cur.code}</span>`
          }, ``)
          $('.carve_emojis_box').html(emojiList)
          
          // 构建 emojiMap 并挂载到 that
          that.emojiMap = new Map();
          $('.emoji_item_font').each((index, item) => {
            const key = $(item).html();
            const val = $(item).attr('emoji').replace('_emoji_', '&#');
            that.emojiMap.set(key, val);
          });
          
          choiceEmoji();
          // 刷新预览（此时 emojiMap 已就绪）
          that.priewCarveText();
        }).catch(err => console.log(err))
        inputCEvent()
        break;
      case "L":
        // 渲染L面
        renderL()
        break;
      default:
    }

    // AC面公共方法
    function commonFun(ptside) {
      getInitData()
      $('.AC_face_exp_close').on('click', function () {
        if(ptside == 'A' || ptside == 'C' || ptside == 'Z'){
          $('.AC_face_exp').hide();
        }else if(ptside == 'L'){
          $('.L_face_exp').hide();
        }
      })
      $('.AC_face_exp_show').on('click', function () {
        if(ptside == 'A' || ptside == 'C' || ptside == 'Z'){
          $('.AC_face_exp').css('display', 'flex');
        }else if(ptside == 'L'){
          $('.L_face_exp').css('display', 'flex');
        }
      })
    }

    let dataA = null, dataC = null, dataL = null;
    // 获得初始化A/C面数据
    function getInitData() {
      const data = that._model._parent._data.personalizations
      data.forEach((item) => {
        if (item.ptside === 'A') {
          dataA = item
        } else if (item.ptside === 'C' || item.ptside === 'Z') {
          dataC = item
        } else if(item.ptside === 'L'){
          dataL = item
        } else {
          dataA,
          dataC,
          dataL = {}
        }
      })
    }

    // 初始化C面页面
    function initCFace() {
      const inputDom = $('#text-input')
      // 原始已选中的私定信息的刻字类型（C/Z 面）
      const originalPtmode = that._model._parent._data.personalizations?.find(item => item?.ptside == 'C' || item?.ptside == 'Z')?.ptmode;
      // 仅当原选中就是自定义刻字('2')时才回显刻字文案；
      // 若原选中是明星刻字('3')（例如签名已下架被强制切到自定义刻字），则输入框应为空，避免把明星签名文案错误回显
      if(that.ptMode == '2' && originalPtmode == '2'){
        inputDom.val(that._model.cPTword)
      }
      
      // 清空input框
      $('.carve_clear_input').on('click', function () {
        $('#text-input').val('');
        that.priewCarveText();
        $(this).hide();
      });
      
      // 初始化字体
      const $fontItems = $('.font-item');
      // 有字体选择器
      if ($fontItems.length > 0) {
          const savedFontId = dataC?.fontId;
          let $activeFont = null;
          if (savedFontId) {
              $activeFont = $fontItems.filter((_, el) => $(el).data('fontid') == savedFontId);
          }
          if (!$activeFont || !$activeFont.length) {
              $activeFont = $fontItems.eq(0);
          }
          // 高亮激活的字体项
          $fontItems.removeClass('active');
          $activeFont.addClass('active');
      
          // 获取字体数据并应用到实例和样式
          const fontFamily = $activeFont.data('fontfamily');
          const fontId = $activeFont.data('fontid');
          const ttfUrl = $activeFont.data('ttfurl');
          const fontName = $activeFont.find('.font-name').text();
      
          that.selectedFontFamily = fontFamily;
          that.selectedFontId = fontId;
          that.ttfUrl = ttfUrl;
          that.fontName = fontName;
      
          const inputFontFamily = `${fontFamily}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
          $('#text-input').css('font-family', inputFontFamily);
          that.priewCarveText();   // 刷新预览
      } else {
          // 没有字体选择器：默认字体栈
          const defaultUserFont = 'Helvetica Neue, Helvetica, Arial, Microsoft Yahei, 微软雅黑, PingFang SC, Heiti, sans-serif, SimSun, serif';
          that.selectedFontFamily = defaultUserFont;
          const inputFontFamily = `${defaultUserFont}, 'lenovo-emoji', 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
          $('#text-input').css('font-family', inputFontFamily);
          that.priewCarveText();
      }
      
      // 刻字价渲染已在模板中根据 position 接口 _cSideData[0] 的 activityPrice/price 完成，此处不再覆盖
    }

    // 计算input内容长度
    function getInputTextLen(textArr = []) {
      const emojiMap = that.emojiMap || new Map();
      const inputTextLen = textArr.reduce((pre, cur) => {
        return pre + (emojiMap.get(cur) ? that.emojiLength : 1)
      }, 0);
      return inputTextLen;
    }

    // 生成emoji map
    function handleEmojiMap() {
      let emojiMap = new Map();
      $('.emoji_item_font').each((index, item) => {
        const key = $(item).html();
        const val = $(item).attr('emoji').replace('_emoji_', '&#');
        emojiMap.set(key, val);
      });
      return emojiMap;
    }

    // 选择emoji表情
    function choiceEmoji() {
      $('.emoji').on('touchstart', function () {
        $(this).addClass('choice_expression');
      }).on('touchend', function () {
        $(this).removeClass('choice_expression');
      });

      $('.emoji').on('click', function () {
        $('.carve_clear_input').show()
        const inputDom = document.getElementById('text-input')
        const inputArr = inputDom.value.split('')
        const inputTextLen = getInputTextLen(inputArr)
        if (inputTextLen >= that.inputWordsLimit) {
          $('.personal_text_content_r_remind').css('color', '#EF1E0B')
          setTimeout(() => {
            $('.personal_text_content_r_remind').css('color', '#BDBDBD')
          }, 3000)
          return
        } else {
          const index = inputDom.selectionStart
          if (index === inputArr.length) {
            inputDom.value = inputDom.value + this.innerText
          } else {
            inputArr.splice(index, 0, this.innerText)
            inputDom.value = inputArr.join('')
          }
          inputDom.setSelectionRange(index + 1, index + 1)
        }
        that.priewCarveText()
      })
    }


    // input输入事件
    function inputCEvent() {
      // oninput是否为拼音输入  
      let recoverTime = null
      let flag = true;
      let inputTextArrEnd = []
      $('#text-input').on('compositionstart', function () {
        const inputDom = document.getElementById('text-input')
        const compositionstartIndex = inputDom.selectionStart
        inputTextArrEnd = inputDom.value.split('').slice(compositionstartIndex)
        flag = false;
      })
      $('#text-input').on('compositionend', function () {
        const inputDom = document.getElementById('text-input')
        let index = inputDom.selectionStart - inputTextArrEnd.length
        const inputTextArr = inputDom.value.split('')
        while (getInputTextLen(inputTextArr) > 15) {
          $('.personal_text_content_r_remind').css('color', '#EF1E0B')
          inputDom.blur()
          inputTextArr.splice(--index, 1)
        }
        if (recoverTime !== null) {
          clearTimeout(recoverTime);
        }
        recoverTime = setTimeout(() => {
          $('.personal_text_content_r_remind').css('color', '#BDBDBD')
        }, 3000)
        inputDom.value = inputTextArr.join('')
        flag = true;
        $('#text-input').trigger("input")
      })
      let time = null
      $('#text-input').on('input', function () {
        const inputDom = document.getElementById('text-input')
        if (!flag) return
        const inputTextArr = inputDom.value.split('')
        let inputTextLen = getInputTextLen(inputTextArr)
        let index = inputDom.selectionStart
        if (inputTextLen > 15) {
          inputDom.blur()
          $('.carve_clear_input').show()
          $('.personal_text_content_r_remind').css('color', '#EF1E0B')
          while (inputTextLen > 15) {
            inputTextArr.splice(index - 1, 1)
            index--
            inputTextLen = getInputTextLen(inputTextArr)
          };
          inputDom.value = inputTextArr.join('')
          if (recoverTime !== null) {
            clearTimeout(recoverTime);
          }
          recoverTime = setTimeout(() => {
            $('.personal_text_content_r_remind').css('color', '#BDBDBD')
          }, 3000)
        } else if (inputTextLen > 0 && inputTextLen <= 15) {
          $('.carve_clear_input').show()
        } else {
          $('.carve_clear_input').hide()
          that.priewCarveText()
          return
        }
        if (time !== null) {
          clearTimeout(time);
        }
        time = setTimeout(() => {
          API.riskCheck({
            sts: 'e40e7004-4c8a-4963-8564-31271a8337d8',
            text: inputDom.value
          }).then(res => {
            if (res.resps.ret == 0 && res.resps.isLegal == 0) {
              that.priewCarveText()
            } else {
              var tips = '重新提交您的刻字内容，您可以尝试输入名字或祝福等，为设备添加个性风格';
              Alert.showTip(tips);
            }
          }).catch(err => {
            console.log(err, 'err');
          })
        }, 500)
      });
      // 点击历史白色词条（input => autocomplete属性）更新预览区刻字文字
      $('#text-input').on('change', function () {
        that.priewCarveText();  // 刷新预览区
      });
    }


    // 获取A面官方喷绘图片数据
    function getAImgs() {
      const navPrice = that._model._aSideData
      const imgs = that._model._pictures
      return { imgs, navPrice }
    }

    // 渲染A面页面
    function renderA() {
      selectedImgMsg.code = dataA.ptpicCode
      selectedImgMsg.name = dataA.picName
      const { imgs, navPrice } = getAImgs()
      let { typeIndex, imgIndex } = findImgPosition(imgs, Number(selectedImgMsg.code))
      typeIndex = typeIndex >= 0 ? typeIndex : 0
      imgIndex = imgIndex >= 0 ? imgIndex : 0
      renderAPriceNav(navPrice)
      choiceAPriceNav()
      renderAClassNav(imgs, typeIndex)
      renderAImgs(imgs[typeIndex].picArr, imgIndex)
      choiceAimgs()
    }
    
     // 渲染A面页面
     function renderL() {
      selectedImgMsg.code = dataL.ptpicCode
      selectedImgMsg.name = dataL.picName
      const { imgs, navPrice } = getAImgs()
      let { typeIndex, imgIndex } = findImgPosition(imgs, Number(selectedImgMsg.code))
      typeIndex = typeIndex >= 0 ? typeIndex : 0
      imgIndex = imgIndex >= 0 ? imgIndex : 0
      renderAPriceNav(navPrice)
      choiceAPriceNav()
      renderAClassNav(imgs, typeIndex)
      renderAImgs(imgs[typeIndex].picArr, imgIndex)
      choiceAimgs()
    }

    // 选择A面图片价格导航
    function choiceAPriceNav() {
      $('.A_price_nav_li').on('click', function () {
        $(this).siblings().removeClass('A_price_nav_li_active')
        $(this).addClass('A_price_nav_li_active')
        imgPriceData.price = $(this).attr('price')
        imgPriceData.activityPrice = $(this).attr('activityprice')
        imgPriceData.priceName = $(this).attr('pricename')
        imgPriceData.codeNav = $(this).attr('codenav')
        API.getPersonalPictures({ code: $(this).attr('code') }).then(res => {
          const data = res.t.data
          const { typeIndex, imgIndex } = findImgPosition(data, Number(selectedImgMsg.code))
          renderAClassNav(data, typeIndex)
          renderAImgs(data[typeIndex === -1 ? 0 : typeIndex].picArr, imgIndex === -1 ? undefined : imgIndex)
        }).catch(err => {
          console.log(err);
        })
      })
    }

    // 选择A面喷绘图片类型导航
    function choiceAClassNav(data) {
      $('.A_img_class_nav_li').on('click', function () {
        $(this).siblings().removeClass('A_img_class_nav_li_active')
        $(this).addClass('A_img_class_nav_li_active')
        const imgs = data.filter(item => {
          return item.cateCode == $(this).attr('cateCode')
        })[0].picArr
        renderAImgs(imgs)
      })
    }
    // 渲染A面图片价格导航
    function renderAPriceNav(data) {
      const navPriceList = data.reduce((pre, cur, index) => {
        return pre + `<li latag='latag_wap_购物车_A面_${index}_null_价格${cur.showPrice}' class="A_price_nav_li" codeNav='${cur.code}' priceName="${cur.showPrice}" price="${cur.price}" activityPrice="${cur.activityPrice}" code="${cur.code}">${cur.showPrice}</li>`
      }, ``)
      $('.A_price_nav_ul').html(navPriceList)
      const aPriceCode = Number(that._model.aPriceCode) || Number(that._model._aSideData[0].code)
      const index = data.findIndex(item => item.code == aPriceCode)
      $('.A_price_nav_ul>li').eq(index).addClass('A_price_nav_li_active')
      $('.carve_price>b').text(data[index].activityPrice)
      imgPriceData.activityPrice = data[index].activityPrice
      imgPriceData.price = data[index].price
      imgPriceData.priceName = data[index].priceName
      imgPriceData.codeNav = data[index].code
      selectedImgMsg.codeNav = imgPriceData.codeNav
      selectedImgMsg.priceName = imgPriceData.priceName
      selectedImgMsg.price = imgPriceData.price
      if (data[index].activityPrice !== data[index].price) {
        $('.carve_price>s').text('¥' + data[index].price)
        $('.carve_price>s').show()
      } else {
        $('.carve_price>s').text('')
        $('.carve_price>s').hide()
      }
    }
    // 渲染A面图片类型导航
    function renderAClassNav(data, typeIndex) {
      const navClassList = data.reduce((pre, cur) => {
        return pre + `<li class="A_img_class_nav_li" cateCode="${cur.cateCode}">${cur.cateName}</li>`
      }, ``)
      $('.A_imgs_box_l_ul').html(navClassList)
      $('.A_img_class_nav_li').eq(typeIndex).addClass('A_img_class_nav_li_active')
      choiceAClassNav(data)
    }
    // 渲染A面喷绘样式图片
    function renderAImgs(data, imgIndex) {
      const imgList = data.reduce((pre, cur, index) => {
        return pre + `<img class="A_imgs_box_r_img_default" latag='latag_wap_购物车_A面官方喷绘图_${index}_${cur.path}_${cur.name}' code="${cur.code}" name="${cur.name}" src="${cur.path}">`
      }, ``)
      $('.A_imgs_box_r').html(imgList)
      if (imgIndex !== undefined) {
        const imgDom = $('.A_imgs_box_r>img').eq(imgIndex)
        imgDom.removeClass('A_imgs_box_r_img_default');
        imgDom.addClass('A_imgs_box_r_img_active')
        getOfficialImg(imgDom.attr('code'), imgDom.attr('src'))
      }
    }
    // 获取A面官方效果图
    function getOfficialImg(code, src) {
      API.getPersonalPrint({ code: code, materialNumber: that.materialCode, goodsCodes }).then(res => {
        if (res.code == 0) {
          $('.A_pre_img').attr('src', res.t && res.t.data && res.t.data[0]).attr('thumb_src', src)
        } else {
          $('.A_pre_img').attr('src', src).attr('thumb_src', src)
        }
      }).catch(err => {
        $('.A_pre_img').attr('src', src).attr('thumb_src', src)
      })
    }
    // 选择A面喷绘图片
    function choiceAimgs() {
      $('.A_imgs_box_r').on('click', function (e) {
        const imgDom = e.target
        if ($(imgDom)[0].tagName === 'DIV') return /* 防止点击非IMG */
        selectedImgMsg.code = $(imgDom).attr('code')
        selectedImgMsg.name = $(imgDom).attr('name')
        $(imgDom).siblings().removeClass('A_imgs_box_r_img_active');
        $(imgDom).siblings().addClass('A_imgs_box_r_img_default');
        $(imgDom).removeClass('A_imgs_box_r_img_default');
        $(imgDom).addClass('A_imgs_box_r_img_active');
        API.getPersonalPrint({ code: $(imgDom).attr('code'), materialNumber: that.materialCode, goodsCodes }).then(res => {
          if (res.code == 0) {
            $('.A_pre_img').attr('src', res.t && res.t.data && res.t.data[0]).attr('thumb_src', $(imgDom).attr('src'))
          } else {
            $('.A_pre_img').attr('src', `${$(imgDom).attr('src')}`).attr('thumb_src', $(imgDom).attr('src'))
          }
        }).catch(err => {
          $('.A_pre_img').attr('src', `${$(imgDom).attr('src')}`).attr('thumb_src', $(imgDom).attr('src'))
        })
        if (imgPriceData.activityPrice !== imgPriceData.price) {
          $('.carve_price>b').text(imgPriceData.activityPrice)
          $('.carve_price>s').text('￥' + imgPriceData.price)
          $('.carve_price>s').show()
        } else {
          $('.carve_price>b').text(imgPriceData.activityPrice)
          $('.carve_price>s').hide()
        }
        selectedImgMsg.price = imgPriceData.price
        selectedImgMsg.codeNav = imgPriceData.codeNav
        selectedImgMsg.priceName = imgPriceData.priceName
      })
    }

    // 定位官方效果图
    function findImgPosition(data, ptpicCode) {
      let typeIndex = 0
      let imgIndex = 0
      typeIndex = data.findIndex(item => {
        imgIndex = item.picArr.findIndex(imgs => {
          return imgs.code === ptpicCode
        })
        return imgIndex >= 0
      })
      return { typeIndex, imgIndex }
    }

    $('.AC_face_exp_close').on('click', function () {
      $('.AC_face_exp').hide()
    })
    $('.AC_face_exp_show').on('click', function () {
      $('.AC_face_exp').css('display', 'flex')
    })
    $("#customized_pop .pro_customed_pric_container .pro_customed_list").eq(index[0]).addClass("on");

    $("#customized_pop  .onClickUl").hide()


    let indexLeft = 0
    let sec = index[1]
    let personalizations = that._model._parent._data.personalizations
    let datas = ''
    personalizations.map((item, index) => {
      if (item.ptside == 'A') {
        datas = item
      }
    })
    if (personalizations && personalizations.length > 0 && !sec) {
      // console.log(that._model._pictures)
      let indexRight = ''
      that._model._pictures.map((item, index) => {
        item.picArr.map((items, indexs) => {
          if (items.code == datas.ptpicCode) {
            indexLeft = index
            indexRight = indexs
          }
        })

      })
      $("#customized_pop .pro_category_cover .srdz_category_list").eq(indexLeft).addClass("on");
      $("#customized_pop  .onClickUl").eq(indexLeft).show();
      let arrrr = $('#customized_pop pro_customed_list_container customized_list').find("[tag='onMouseoverTag']")
      // console.log(arrrr)
      $("#customized_pop  .onClickUl").eq(indexLeft).find("li[tag='onMouseoverTag']").eq(indexRight).addClass("on");


    } else {
      $("#customized_pop .pro_category_cover .srdz_category_list").eq(0).addClass("on");
      $("#customized_pop  .onClickUl").eq(0).show();
    }
    $(".pro_customed_list").off("click").on("click", function (e) {
      $(this).addClass('on').siblings().removeClass('on')
      var code = $(this).attr("codeNav");
      var index = $(this).attr("index");
      // console.log(that._model._parent._personalGoods._view,'that._model._parent')
      that._model._parent.getPersonalPicturess({ code: code }).then(
        x => {
          that._model._parent._personalGoods._view.render("A", index, 'sec')
        }
      ).catch(err => {
        that._model._parent._personalGoods._view.render("A", index, 'sec')
      });
      $("#customized_pop .pro_customed_pric_container .pro_customed_list").eq(index).addClass("on");

    })
    $(".srdz_category_list").off("click").on("click", function (e) {
      $(this).addClass('on').siblings().removeClass('on')
      var index = $(this).attr("index");
      $(this).parents("#customized_pop").find(".onClickUl").hide().eq(index).show()
    })
    $(".customized_list").off("click", "li[tag='onMouseoverTag']").on("click", "li[tag='onMouseoverTag']", function (e) {
      $(this).parents().find("[tag='onMouseoverTag']").removeClass('on')
      $(this).addClass('on')
    })
    this._el.off("click", "[tag='onClickNoneC']").on("click", "[tag='onClickNoneC']", function (e) {
      $(".pop_right").removeClass("in");
      $util.toggleBodyScroller(false);
    })
    $(".pop_right_return").on("click", function () {
      $(".pop_right").removeClass("in");
      $util.toggleBodyScroller(false);
    })

    this._el.off("click", "[tag='presonalOkA']").on("click", "[tag='presonalOkA']", function (e) {
      // console.log($("[tag='onMouseoverTag'].on").attr('code'))
      let code = $("[tag='onMouseoverTag'].on").attr('code')
      let path = $("[tag='onMouseoverTag'].on").attr("data-large")
      let name = $("[tag='onMouseoverTag'].on").attr("name")
      let price = $("[tag='onClicknavLi'].on").attr("price")
      let priceName = $("[tag='onClicknavLi'].on").attr("priceName")
      let codeNav = $("[tag='onClicknavLi'].on").attr("codeNav")
      if (!code || !path) {
        Alert.showTip('请选择图片')
        return false
      }
      let params = {
        price: price, //价格
        priceID: priceName, //价格id
        ptmode: 1, //1 图片 2文字
        ptside: "A", //A面 C面 
        pttype: 1, //1 喷印 2 镭雕
        ptpicCode: code, //图片编码
        pturl: path, //图片地址 文字null
        picName: name, //选择的图片的名称
        ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
      }
      let personalizations = that._model._parent._data.personalizations
      personalizations.map((item, index) => {
        if (item.ptside == params.ptside) {
          personalizations.splice(index, 1, params)
        }
      })
      that._model._parent.modifyItemFromCart({ opsType: 4, content: JSON.stringify(personalizations) });
      $('.pop_right').removeClass('in');
      $util.toggleBodyScroller(false);
    })
    this._el.off("click", "[tag='presonalOkC']").on("click", "[tag='presonalOkC']", function (e) {
      let text = $("#customized_pop_c [tag='onClickInputs']").val()
      var myreg = /^[A-Za-z0-9\u4E00-\u9FA5，。,.!！?？\-—— ]+$/;

      if (!code || !path) {
        Alert.showTip('请选择图片')
        return false
      }
      let params = {
        price: price, //价格
        priceID: priceName, //价格id
        ptmode: 1, //1 图片 2文字
        ptside: "A", //A面 C面 
        pttype: 1, //1 喷印 2 镭雕
        ptpicCode: code, //图片编码
        pturl: path, //图片地址 文字null
        picName: name, //选择的图片的名称
        ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
      }
      let personalizations = that._model._parent._data.personalizations
      personalizations.map((item, index) => {
        if (item.ptside == params.ptside) {
          personalizations.splice(index, 1, params)
        }
      })
      that._model._parent.modifyItemFromCart({ opsType: 4, content: JSON.stringify(personalizations) });
      $('.pop_right').removeClass('in');
      $util.toggleBodyScroller(false);
    }),

      // A面确认喷绘
      $('.sideA_submitOk').off('click').on('click', function () {
        let code = selectedImgMsg.code;
        let name = selectedImgMsg.name;
        let price = selectedImgMsg.price;
        let priceName = selectedImgMsg.priceName;
        let codeNav = selectedImgMsg.codeNav;
        let path = $('.A_pre_img').attr("thumb_src");

        if (!code || !path) {
          Alert.showTip('请选择图片')
          return false
        }
        // 从图片数据中获取pttype，如果是官喷使用接口返回的pttype
        const imgPttype = getSelectedImgPttype(that._model._pictures, Number(code))
        let params = {
          price: price, //价格
          priceID: priceName, //价格id
          ptmode: 1, //1 图片 2文字
          ptside: "A", //A面 C面
          pttype: imgPttype, //1 喷印 2 镭雕，从图片数据中获取
          ptpicCode: code, //图片编码
          pturl: path, //图片地址 文字null
          picName: name, //选择的图片的名称
          ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
        }
        let personalizations = that._model._parent._data.personalizations
        personalizations.map((item, index) => {
          if (item.ptside == params.ptside) {
            personalizations.splice(index, 1, params)
          }
        })
        that._model._parent.modifyItemFromCart({
          opsType: 4,
          content: JSON.stringify(personalizations)
        }).then(res => {
        }).catch(err => {
          console.log('确认修改接口出错error:', err)
        })
        $('.pop_right').removeClass('in');
        $util.toggleBodyScroller(false);
      }),
      // L面确认喷绘
      $('.sideL_submitOk').off('click').on('click', function () {
        let code = selectedImgMsg.code;
        let name = selectedImgMsg.name;
        let price = selectedImgMsg.price;
        let priceName = selectedImgMsg.priceName;
        let codeNav = selectedImgMsg.codeNav;
        let path = $('.A_pre_img').attr("thumb_src");

        if (!code || !path) {
          Alert.showTip('请选择图片')
          return false
        }
        // 从图片数据中获取pttype，如果是官喷使用接口返回的pttype
        const imgPttype = getSelectedImgPttype(that._model._pictures, Number(code))
        let params = {
          price: price, //价格
          priceID: priceName, //价格id
          ptmode: 1, //1 图片 2文字
          ptside: "L", //A面 C面
          pttype: imgPttype, //1 喷印 2 镭雕，从图片数据中获取
          ptpicCode: code, //图片编码
          pturl: path, //图片地址 文字null
          picName: name, //选择的图片的名称
          ptcode: codeNav, //喷绘费/刻字费类型的唯⼀code
        }
        let personalizations = that._model._parent._data.personalizations
        personalizations.map((item, index) => {
          if (item.ptside == params.ptside) {
            personalizations.splice(index, 1, params)
          }
        })
        that._model._parent.modifyItemFromCart({
          opsType: 4,
          content: JSON.stringify(personalizations)
        }).then(res => {
        }).catch(err => {
          console.log('确认修改接口出错error:', err)
        })
        $('.pop_right').removeClass('in');
        $util.toggleBodyScroller(false);
      }),
      // C面确认刻字
      $('.sideC_submitOk').off('click').on('click', function (e) {
        const machineProductType = $(this).attr('machineProductType');
        const ptmode = that.ptMode;
        const ptside = $(this).attr('ptside');
        const pttype = $(this).attr('pttype');
        // 手机官方签名刻字的提交逻辑
        // 所有设备类型的明星刻字
        if(ptmode == '3'){
          // 明星签名 tab 下必须已选中一张签名（覆盖强制切换、原签名下架等未默认选中场景）
          if(!that.submitInfo?.ptPicCode){
            Alert.showTip('请选择签名');
            return;
          }
          let code = $(this).attr('code');
          let price = $(this).attr('price');
          let priceID = $(this).attr('priceName');
          let ptword = that.submitInfo.ptWord;
          let pturl = that.submitInfo.ptUrl
          let spurl = that.submitInfo.ptEffectUrl
          let ptpicCode = that.submitInfo.ptPicCode
          let params = { price: price, priceID: priceID, ptmode: ptmode, ptside: ptside, pttype, ptword , ptcode: code, pturl, spurl, ptpicCode }
          let personalizations = that._model._parent._data.personalizations
          personalizations.map((item, index) => {
              if (item.ptside == params.ptside) {
                  personalizations.splice(index, 1, params)
              }
          })
          that._model._parent.modifyItemFromCart({
              opsType: 4,
              content: JSON.stringify(personalizations)
          }).then(modifyRes => {
            //console.log('wap修改刻字成功', modifyRes);
          }).catch(modifyErr => {
            console.log('wap修改接口error:', modifyErr);
          })
          $('.pop_right').removeClass('in');
          $util.toggleBodyScroller(false);
          return;
        }
        // 常规刻字的提交逻辑
        // 转义emoji
        const inputText = $('#text-input').val()
        if (!inputText.replace(/\s+/g, '')) {
          Alert.showTip('请输入刻字内容')
          return
        }
        function emojiConvert(text = '') {
          const emojiMap = handleEmojiMap();
          let dto = '';
          text.split('').forEach((item) => {
            dto += emojiMap.get(item) ? emojiMap.get(item) : item;
          });
          return dto;
        }
        let text = emojiConvert($('#text-input').val());
        if (text.length === 0) {
          Alert.showTip('请输入刻字内容')
          return;
        }
        API.riskCheck({
          sts: 'e40e7004-4c8a-4963-8564-31271a8337d8',
          text: text
        }).then(res => {
          if (res.resps.ret == 0 && res.resps.isLegal == 0) {
            let code = $(this).attr('code')
            let price = $(this).attr('price')
            let priceID = $(this).attr('priceName')
            //let params = { price: price, priceID: priceID, ptmode: 2, ptside: 'C', pttype: 1, ptword: text, ptcode: code }
            let params = { 
              price: price, 
              priceID: priceID, 
              ptmode: ptmode, 
              ptside: ptside, 
              pttype: pttype, 
              ptword: text, 
              ptcode: code,
              fontId: that.selectedFontId,
              ttfUrl: that.ttfUrl, 
              fontName: that.fontName
            }
            // 自定义刻字
            if(ptmode == '2'){
              // 开关打开
              if(that._model.machineInfo?.mobileList?.length > 0){
                params.pturl = that._model.machineInfo?.mobileList?.find(item => item?.ptMode == ptmode)?.ptUrl;
              // 开关关闭（仅自定义刻字）
              }else{
                params.pturl = that._model.machineInfo?.ptUrl;
              }
            }
            let personalizations = that._model._parent._data.personalizations
            personalizations.map((item, index) => {
              if (item.ptside == params.ptside) {
                personalizations.splice(index, 1, params)
              }
            })
            that._model._parent.modifyItemFromCart({
              opsType: 4,
              content: JSON.stringify(personalizations)
            }).then(modifyRes => {
              //console.log('wap修改刻字成功', modifyRes);
            }).catch(modifyErr => {
              console.log('wap修改接口error:', modifyErr);
            })

            $('.pop_right').removeClass('in');
            $util.toggleBodyScroller(false);
          } else {
            var tips = '重新提交您的刻字内容，您可以尝试输入名字或祝福等';
            Alert.showTip(tips);
          }
        }).catch(err => {
          console.log('risk check wap失败', err)
        });
      })
  }
}

